/* This file is generated by createIcons.js any changes will be lost. */
import createIcon from '../createIcon';

var UserMinusIcon = createIcon({
  name: 'UserMinusIcon',
  height: 512,
  width: 640,
  svgPath: 'M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z',
  yOffset: '',
  xOffset: '',
  transform: ''
});

export default UserMinusIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-icons/dist/esm/icons/user-minus-icon.js
// module id = 1072
// module chunks = 0